// extracted by mini-css-extract-plugin
export default {"imageContainer":"P37eeY","defaultImage":"Il60Mt","defaultImageMobile":"awuoxZ"};